import AIStatsWidgetComponent from 'flow/components/ai-coworker/AIStatsWidgetComponent';
import useAppContext from 'flow/hooks/useAppContext';
import React from 'react';

interface Props {
    satisfactionRate?: number;
    isLoading?: boolean;
    hasStats?: boolean;
}

const AIEvalsSatisfactionRate = ({
    satisfactionRate,
    isLoading,
    hasStats,
}: Props) => {
    const { i18next } = useAppContext();
    const hasData =
        hasStats && satisfactionRate !== undefined && satisfactionRate !== null;

    return (
        <AIStatsWidgetComponent
            i18Key="aicoworker.statistics.satisfactionRate"
            value={
                hasData
                    ? `${(satisfactionRate * 100).toFixed(0)}%`
                    : i18next.t('aicoworker.statistics.noData')
            }
            className={
                hasData
                    ? `bg-green-100 text-3xl dark:bg-green-200`
                    : `bg-gray-200 text-base dark:bg-gray-700`
            }
            isLoading={isLoading}
            hasStats={hasStats}
        />
    );
};

export default AIEvalsSatisfactionRate;
